import React from 'react';
import { Chip } from '@mui/material';

const FAIXA_COLORS: Record<string, string> = {
  'C': '#ef4444',
  'C+': '#f97316',
  'B': '#eab308',
  'B+': '#22c55e',
  'A': '#16a34a',
};

interface FaixaBadgeProps {
  faixa: string;
  size?: 'small' | 'medium';
}

const FaixaBadge: React.FC<FaixaBadgeProps> = ({ faixa, size = 'small' }) => {
  const color = FAIXA_COLORS[faixa] || '#94a3b8';

  return (
    <Chip
      label={faixa}
      size={size}
      sx={{
        backgroundColor: color,
        color: '#fff',
        fontWeight: 700,
        fontSize: size === 'medium' ? '1rem' : '0.75rem',
        minWidth: size === 'medium' ? 48 : 36,
      }}
    />
  );
};

export default FaixaBadge;
